import { Option, SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { Label } from 'reactstrap';
import { METRIC_OVERRIDE_CODES, MetricOverrideType } from './types';
import { getLabelByCode, getOptionsByCode } from './utils';

interface Props {
  form: MetricOverrideType;
  handleChange: <K extends keyof MetricOverrideType>(props: { code: K; value: MetricOverrideType[K] }) => void;
}

interface SelectProps<K extends keyof MetricOverrideType> extends Props {
  code: K;
  options: Option<MetricOverrideType[K]>[];
  className: string;
}

const SelectComponent = <K extends keyof MetricOverrideType>(props: SelectProps<K>) => {
  const { code, options, form, handleChange, className } = props;

  return (
    <>
      <Label for={code} className={className}>
        {getLabelByCode(code)}
      </Label>
      <SelectFactory
        selectType={SelectTypes.SingleSelect}
        options={options}
        value={options.find((op) => op.value === form[code]) ?? null}
        onChange={(op) => (op?.value ? handleChange({ code, value: op.value }) : undefined)}
        isMenuPortalTargetBody
        menuPlacement='top'
      />
    </>
  );
};

export const SingleMetricOverride = (props: Props) => {
  return (
    <>
      {METRIC_OVERRIDE_CODES.map((code, index) => (
        <SelectComponent
          {...props}
          key={code}
          code={code}
          options={getOptionsByCode(code)}
          className={index ? 'mt-3 fw-semibold' : 'fw-semibold'}
        />
      ))}
    </>
  );
};
